export const ACADEMY_PREFIX = "/academy";

export const Routes = {
  ACADEMY: {
    path: ACADEMY_PREFIX,
    name: "Academy"
  },
  ACADEMY_STORAGE_ORGANIZATION: {
    path: `${ACADEMY_PREFIX}/storage/organization`,
    name: "StoragePage"
  },
  ACADEMY_STORAGE_ORGANIZATION_ROOT_FOLDER: {
    path: `${ACADEMY_PREFIX}/storage/:orgId/:teamId?/organization`,
    name: "StoragePage"
  },
  ACADEMY_STORAGE_ORGANIZATION_SUB_FOLDER: {
    path: `${ACADEMY_PREFIX}/storage/:orgId/:teamId?/organization/:folderId`,
    name: "StoragePage"
  },
  ACADEMY_STORAGE_PLAYER_ORGANIZATION: {
    path: `${ACADEMY_PREFIX}/storage/organization/:organizationId/player/:playerId`,
    name: "StoragePage"
  },
  ACADEMY_STORAGE_PLAYER_ORGANIZATION_SUB_FOLDER: {
    path: `${ACADEMY_PREFIX}/storage/organization/:organizationId/player/:playerId/:folderId`,
    name: "StoragePage"
  },
  ACADEMY_ASSIGNMENT: {
    path: `${ACADEMY_PREFIX}/assignment/organization`,
    name: "AssignmentsPage"
  },
  ACADEMY_ASSIGNMENT_ORGANIZATION: {
    path: `${ACADEMY_PREFIX}/assignment/:orgId/:teamId?/organization`,
    name: "AssignmentsPage"
  },
  ACADEMY_ASSIGNMENT_PLAYER: {
    path: `${ACADEMY_PREFIX}/assignment/organization/:organizationId/player/:playerId`,
    name: "AssignmentsPage"
  },
  ORGANIZATION_SETTINGS: {
    path: "/settings/:id/:page",
    name: "Organization Settings"
  },
  RECORDINGS: {
    path: "/recordings",
    name: "Recordings"
  },
  CHAT: {
    path: `/:orgId?/:teamId?/chat/:conversationSid?`,
    name: "Chat"
  },
  PAYMENTS: {
    path: "/:orgId?/:teamId?/payments",
    name: "Payments"
  },
  BILLING: {
    path: "/:orgId/billing",
    name: "Billing"
  },
  SUBSCRIPTIONS_SIGNUP: {
    path: "/subscriptions/signup",
    name: "Subscriptions Signup"
  },
  SUBSCRIPTIONS_LICENSES: {
    path: "/:orgId?/subscriptions/licenses",
    name: "Subscriptions Licenses"
  },
  SUBSCRIPTIONS_SELECT: {
    path: "/:orgId?/subscriptions/select",
    name: "Subscriptions Select"
  },
  SUBSCRIPTIONS_CHECKOUT: {
    path: "/:orgId?/subscriptions/checkout",
    name: "Subscriptions Checkout"
  },
  ORGANIZATIONS: {
    path: "/organizations",
    name: "Organizations"
  },
  HEALTHCHECK: {
    path: `/healthcheck`,
    name: "HealthCheck"
  },
  HEALTHREVIEW: {
    path: `/healthreview`,
    name: "HealthReview"
  },
  CREATETEAM: {
    path: `/createteam/:orgId`,
    name: "CreateTeam"
  },
  TODAY: {
    path: `/today`,
    name: "Today"
  },

  FAN_PLAYERS: {
    path: "/players",
    name: "FanPlayers"
  },
  COACH_TEAMS: {
    path: "/:orgId/:teamId?/teams/:menu?",
    name: "CoachTeams"
  },
  FAN_CALENDAR: {
    path: `/calendar`,
    name: "FanCalendar"
  },
  TEAM_CALENDAR: {
    path: "/:orgId/:teamId?/calendar",
    name: "TeamCalendar"
  },
  FAN_EMAIL: {
    path: `/email`,
    name: "FanEmail"
  },
  TEAM_EMAIL: {
    path: `/:orgId/:teamId?/email`,
    name: "TeamEmail"
  },
  CREATE_REGISTRATION: {
    path: `/:orgId/:teamId?/registrations`,
    name: "Create Registration"
  },
  TEAM_REGISTRATION: {
    path: `/:orgId/:teamId?/team-registration/:id`,
    name: "Team Registration"
  },
  EVENT_REGISTRATION: {
    path: `/:orgId/:teamId?/event-registration/:id`,
    name: "Event Registration"
  },
  ADMIN: {
    path: `/admin`,
    name: "Admin",
    children: {
      MANDRILL: {
        path: "/admin/mandrill",
        name: "Mandrill"
      },
      REPORTS: {
        path: "/admin/reports",
        name: "Reports",
        children: {
          ORGANIZATIONSUBSCRIPTIONS: {
            path: "/admin/reports/organization-subscriptions",
            name: "Organization Subscriptions"
          },
          ORGLIST: {
            path: "/admin/reports/org-list",
            name: "Org List"
          },
          STATS: {
            path: "/admin/reports/stats",
            name: "stats"
          }
        }
      }
    }
  },
  // REGISTER: {
  //   path: `/register/:registrationId`,
  //   children: [
  //     {
  //       path: "error",
  //       name: "Register Error",
  //       component: () =>
  //         import("@/views/Registration/PlayerRegistration/views/Error.vue")
  //     },
  //     {
  //       path: "",
  //       name: "Register",
  //       component: () =>
  //         import(
  //           "@/views/Registration/PlayerRegistration/views/RegisterPlayer.vue"
  //         )
  //     },
  //     {
  //       path: "org-unit/:orgUnitId/player/:playerId",
  //       name: "Register",
  //       component: () =>
  //         import(
  //           "@/views/Registration/PlayerRegistration/views/RegisterPlayer.vue"
  //         )
  //     },
  //     {
  //       path: "org-unit/:orgUnitId/",
  //       name: "Register",
  //       component: () =>
  //         import(
  //           "@/views/Registration/PlayerRegistration/views/RegisterPlayer.vue"
  //         )
  //     },
  //     {
  //       path: "player/:playerId",
  //       name: "Register",
  //       component: () =>
  //         import(
  //           "@/views/Registration/PlayerRegistration/views/RegisterPlayer.vue"
  //         )
  //     }
  //   ]
  // },
  PLAYER_REGISTRATION: {
    path: `/register/:registrationId`,
    name: "Player Registration"
  },
  PLAYER_REGISTRATION_TO_SPECIFIC_TEAM: {
    path: `/register/:registrationId/org-unit/:orgUnitId`,
    name: "Player Registration"
  },
  PLAYER_REGISTRATION_DETAILS: {
    path: `/register/:registrationId/player/:playerId`,
    name: "Player Registration"
  },
  NEW_PLAYER_REGISTRATION_DETAILS: {
    path: `/register/:registrationId`,
    name: "Player Registration"
  },
  PLAYER_REGISTRATION_TO_SPECIFIC_TEAM_DETAILS: {
    path: `/register/:registrationId/org-unit/:orgUnitId/player/:playerId`,
    name: "Player Registration"
  },
  NEW_PLAYER_REGISTRATION_TO_SPECIFIC_TEAM_DETAILS: {
    path: `/register/:registrationId/org-unit/:orgUnitId`,
    name: "Player Registration"
  },
  CHECKOUT_PAGE: {
    path: "/pay/:id",
    name: "CheckoutPage"
  },
  LOGOUT: {
    path: `/logout`,
    name: "Logout"
  },
  LOGIN: {
    path: `/login`,
    name: "Login"
  },
  NOT_FOUND: {
    path: "/:catchAll(.*)",
    name: "NotFound"
  }
};
